import React, { useState, useEffect } from "react";
import Leftpanel from "../layout/Leftpanel";
import Header from "../layout/Header";
import aboutbnr from "../../images/aboutbnr.jpg";
import {
  getCmsList,
  getCMSTeams,
  getCMSPartners,
} from "../../../service/cms/cms";

import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import prdt from "../../images/prdtl.jpg";

const Aboutus = ({ Logo }) => {
  const [content, setContent] = useState("");
  const [CMSTeams, setCMSTeams] = useState([]);
  const [partner, setPartner] = useState([]);
  useEffect(() => {
    getCmsList("ABOUT_US")
      .then((res) => {
        //    console.log(res?.data?.data[0]?.text,"resData")
        setContent(res?.data?.data[0]?.text);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  useEffect(() => {
    getCMSTeams()
      .then((res) => {
        // console.log(res.data.data,'resData')
        setCMSTeams(res.data.data);
        //    console.log(res?.data?.data[0]?.text,"resData")
        //    setContent(res?.data?.data[0]?.text)
      })
      .catch((err) => {
        console.log(err);
      });
    getCMSPartners()
      .then((res) => {
        // console.log(res.data.data,"resData")
        setPartner(res.data.data);
        //    console.log(res?.data?.data[0]?.text,"resData")
        //    setContent(res?.data?.data[0]?.text)
      })
      .catch((err) => {
        console.log(err);
      });
  }, [content]);

  const teamResp = {
    0: {
      items: 1,
    },
    800: {
      items: 2,
    },
    1100: {
      items: 3,
    },
    1200: {
      items: 4,
    },
  };

  const partnerResp = {
    0: {
      items: 1,
    },
    800: {
      items: 2,
    },
    1100: {
      items: 3,
    },
    1200: {
      items: 5,
    },
  };

  return (
    // <div className='loginBg'>
    <div
      className={
        localStorage.getItem("gs3_AuthToken")
          ? "container-fluid"
          : "container-fluid aboutMain"
      }
    >
      {/* <span className='logo'><img src={Logo} alt='' /></span> */}
      <div className="dbMain">
        <Leftpanel />
        <div className="dbRight">
          <Header link="#" breadcm="" title="About Us" description="" />
          <div className="commonBase">
            <div className="aboutBase">
              {/* {localStorage.getItem('gs3_AuthToken')? <img src={aboutbnr} alt=''/> : <h2 className='text-center pb-4'>About Us</h2>} */}
              {localStorage.getItem("gs3_AuthToken") ? (
                ""
              ) : (
                <h2 className="text-center pb-4">About Us</h2>
              )}
              <div dangerouslySetInnerHTML={{ __html: content }} />
              <h3>Our Team Members</h3>
              <OwlCarousel
                className="owl-theme"
                // loop
                // items={4}
                margin={16}
                autoplay
                nav={true}
                dots={false}
                responsive={teamResp}
              >
                {CMSTeams.length &&
                  CMSTeams.map((item, index) => {
                    return (
                      <div className="item">
                        <div className="teamCard">
                          <img
                            src={`https://nodeserver.mydevfactory.com:8000/uploads/customer/${item.img}`}
                            alt=""
                          />
                          <h5>{item?.name}</h5>
                          <h6>{item?.position}</h6>
                        </div>
                      </div>
                    );
                  })}
              </OwlCarousel>
              <br /> <br />
              {/* <h3>Our Partners</h3>
              <OwlCarousel
                className="owl-theme"
                margin={16}
                autoplay
                nav={true}
                dots={false}
                responsive={partnerResp}
              >
                {partner.length > 0 &&
                  partner.map((item, index) => {
                    return (
                      <div className="item">
                        <div className="partnr">
                          <img
                            src={`https://nodeserver.mydevfactory.com:8000/uploads/customer/${item.img}`}
                            alt=""
                            height={150}
                            width={150}
                            style={{ maxWidth: "75px", maxHeight: "75px" }}
                          />
                        </div>
                      </div>
                    );
                  })}
              </OwlCarousel> */}
            </div>
          </div>
        </div>
      </div>
    </div>

    // </div>
  );
};

export default Aboutus;
